export const candidateChoicesKeys = {
  all: ["candidate-choices"] as const,
  list: () => [...candidateChoicesKeys.all, "list"] as const,
  byCandidate: (candidateId: string) =>
    [...candidateChoicesKeys.all, "by-candidate", candidateId] as const,
};
